import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  getAllPlans,
  activateFreePlan,
} from "../../../services/api/getAllPlans";

import { updateUserPlan } from "../../../actions/userActions";

import { formatPlan, isFreePlan } from "../../planUtils";

export default function useSubscriptionPlans({ userId, currentPlanId }) {
  const dispatch = useDispatch();

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchPlans = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getAllPlans();

        const apiPlans = Array.isArray(response.data?.data)
          ? response.data.data
          : [];

        const formattedPlans = apiPlans.map(formatPlan);

        if (!isMounted) {
          return;
        }

        setPlans(formattedPlans);

        if (!currentPlanId && userId) {
          const freePlan = formattedPlans.find(isFreePlan);

          if (freePlan) {
            try {
              const response = await activateFreePlan({
                userId,
                selectedPlan: freePlan.title,
              });

              const activeId =
                response.data?.data?.plan_id || freePlan.id || freePlan.title;

              if (isMounted) {
                dispatch(updateUserPlan(activeId));
              }
            } catch (autoError) {
              console.error("Failed to auto-activate Free Plan:", autoError);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching subscription plans:", error);

        if (isMounted) {
          setError(
            "Failed to load subscription plans. Please try refreshing the page.",
          );
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchPlans();

    return () => {
      isMounted = false;
    };
  }, [userId, currentPlanId, dispatch]);

  return {
    plans,
    loading,
    error,
  };
}
